/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Flex, useColorMode, useColorStyle } from '@tonic-one/react';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { V1InstanceApi } from '@Apis';
import EmailAndCollaborationProtection from '../components/EmailAndCollaborationProtection';
import GradientBackground from '../components/GradientBackground';
import EnableSolutions from './EnableSolutions';

interface InstancesResponse {
  orgId: string;
  orgName: string;
  isConnected: boolean;
  instanceId: string;
}

const UpdateToVisionOne = ({
  loadingStepUpStatus,
  isUpgradeLoading,
  isUpgradeDone,
  setLoading,
}: {
  isUpgradeLoading: boolean;
  isUpgradeDone: boolean;
  setLoading: (loading: boolean) => void;
  loadingStepUpStatus: (timer: ReturnType<typeof setInterval> | null) => void;
}) => {
  const { t } = useTranslation();
  const [isConnectedInstanceDone, setIsConnectedInstanceDone] = useState(false);
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  const timeRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    (async function doCall() {
      if (isUpgradeLoading) {
        if (timeRef.current) {
          clearInterval(timeRef.current);
        }

        timeRef.current = setInterval(async () => {
          loadingStepUpStatus(timeRef.current);
        }, 10000);
        loadingStepUpStatus(timeRef.current);
      }
    })();
  }, [isUpgradeLoading]);

  useEffect(() => {
    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }
    };
  }, []);

  async function getInstanceStatus() {
    try {
      setLoading(true);
      const instancesResponse: InstancesResponse[] =
        (await V1InstanceApi.getCasInstances()) as any;
      const instance = instancesResponse.find(
        (inst: InstancesResponse) => inst.isConnected === true
      );

      if (instance) {
        setIsConnectedInstanceDone(true);
      }
    } catch (error) {
      console.error('getInstanceStatus error:', error);
      setIsConnectedInstanceDone(false);
      window.showNotification({
        titleMsg: t('common.apiException.internalError'),
        severity: 'error',
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    (async function doCall() {
      await getInstanceStatus();
    })();
  }, []);

  return (
    <Box
      position="relative"
      width="100%"
      minHeight="100vh"
      backgroundColor={colorStyle.background.primary}
    >
      <GradientBackground />

      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        minHeight="100vh"
        px="96px"
        py="64px"
        position="relative"
        zIndex={1}
      >
        {/* Main Content */}
        <Box width="100%" maxWidth="866px" mb="24px">
          <EmailAndCollaborationProtection setLoading={setLoading} />
        </Box>

        {/* Enable Solutions Card */}
        <Box width="100%" maxWidth="866px">
          <EnableSolutions
            isUpgradeLoading={isUpgradeLoading}
            isConnectedInstanceDone={isConnectedInstanceDone}
            isUpgradeDone={isUpgradeDone}
          />
        </Box>
      </Flex>
    </Box>
  );
};
export default UpdateToVisionOne;
